export const defaultBackgroundImage =
  'https://static.wixstatic.com/media/11062b_afc56c8cc31c46eeabbec328b1a08736~mv2.jpeg';
